module.exports = __webpack_public_path__ + "media/images/experiences/fis-db0062d7370c173d3ca58ddd9d1a3396.jpg";